var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgR = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 22.8 29.4",
    width: 22.8,
    height: 29.4,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_zT9MPvECJZ6QRAnvIVf3RDxHJJcbW2ij"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8,
    height: 29.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_zT9MPvECJZ6QRAnvIVf3RDxHJJcbW2ij)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 77.27 14.669 C 77.27 23.186 71.596 29.3 63.252 29.3 C 55.363 29.3 49.497 23.689 49.497 14.669 C 49.497 4.982 56.459 0 63.516 0 C 70.279 0 77.27 4.724 77.27 14.669 Z  M 70.441 14.669 C 70.441 10.603 68.474 5.884 63.363 5.884 C 58.73 5.884 56.289 9.869 56.289 14.669 C 56.289 20.064 59.297 23.456 63.363 23.456 C 68.475 23.456 70.441 18.787 70.441 14.669 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 46.997 26.637 C 45.326 27.755 41.81 29.274 37.017 29.274 C 27.599 29.274 22.946 22.776 22.946 14.837 C 22.945 5.899 29.269 0 37.533 0 C 41.627 0 44.255 0.683 46.584 1.822 L 44.197 7.329 C 42.422 6.586 40.373 6.147 37.945 6.147 C 31.972 6.147 29.945 9.721 29.945 14.655 C 29.945 19.981 32.666 23.434 37.406 23.434 C 39.121 23.434 40.41 23.067 40.807 22.809 L 40.807 17.856 L 35.995 17.856 L 36.003 12.25 L 46.993 12.25 L 46.997 26.637 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 14.828 28.811 C 13.892 25.4 12.327 22.805 11.036 21.146 C 9.947 19.746 9.099 19.446 9.099 19.446 C 8.219 19.47 7.614 19.467 6.807 19.43 L 6.807 28.81 L 0.233 28.81 L 0.233 0.752 C 1.617 0.528 2.61 0.407 4.061 0.273 C 5.4 0.148 6.911 0.067 8.586 0.067 C 10.803 0.067 12.686 0.312 14.232 0.801 C 15.779 1.29 17.042 1.961 18.022 2.812 C 19.027 3.664 19.749 4.72 20.187 5.88 C 20.651 7.014 20.883 8.226 20.883 9.515 C 20.883 11.216 20.467 12.865 19.562 14.275 C 18.758 15.527 17.408 16.809 16.01 17.691 L 16.01 17.815 C 19.134 19.244 20.903 23.845 22.618 28.811 L 14.828 28.811 Z  M 14.287 9.675 C 14.287 8.489 13.861 7.539 13.011 6.895 C 12.16 6.224 10.99 5.896 9.573 5.874 C 9.416 5.872 8.804 5.878 8.437 5.891 C 8.075 5.9 7.11 5.987 6.808 6.042 L 6.808 14.126 C 7.246 14.178 8.156 14.219 8.896 14.219 C 10.468 14.219 11.931 13.786 12.86 13.066 C 13.788 12.317 14.287 11.119 14.287 9.675 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -22.867 22.093 L -22.867 0.464 L -3.56 0.464 L -3.555 6.496 L -16.292 6.496 L -16.292 11.349 L -5.513 11.349 L -5.506 17.074 L -16.292 17.074 L -16.292 20.106 C -16.292 22.011 -15.173 22.817 -13.714 22.817 C -10.753 22.817 -3.035 22.816 -3.035 22.816 L -3.027 28.81 L -16.199 28.81 C -21.132 28.81 -22.867 26.533 -22.867 22.093 Z ",
    fill: "rgb(255,255,255)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/r.0c472ad8670b941dd9b9a02ffb71a5e9.svg";